(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["limetree-carousel-alignment"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async function(event) {
  var form = event.target;
  if (!form.matches('.lt-quick-shop__form')) return;
  event.preventDefault();
  if (form.dataset.busy === 'true') return;
  var button = form.querySelector('button[type="submit"]');
  var status = form.querySelector('.lt-quick-shop__status');
  var cartLink = form.querySelector('[data-quick-cart]');
  var original = button.textContent;
  var body = new FormData(form);
  form.dataset.busy = 'true';
  button.disabled = true;
  button.textContent = form.dataset.adding;
  status.textContent = '';
  cartLink.hidden = true;
  try {
    var response = await fetch(form.action + '.js', {method: 'POST', body: body, headers: {'Accept': 'application/json'}});
    var result = await response.json();
    if (!response.ok) throw new Error(result.description || form.dataset.error);
    status.textContent = form.dataset.added;
    cartLink.hidden = false;
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
  } catch (error) {
    status.textContent = error.message || form.dataset.error;
  } finally {
    form.dataset.busy = 'false';
    button.disabled = false;
    button.textContent = original;
  }
});


(function () {
  var pending = false;
  var observed = new WeakSet();
  var widths = new WeakMap();
  function alignCarousels() {
    pending = false;
    document.querySelectorAll('.ProductList--carousel').forEach(function (list) {
      if (!observed.has(list)) {
        observed.add(list);
        resizeObserver.observe(list);
      }
      var titles = Array.from(list.querySelectorAll('.ProductItem:not(.ProductItem--horizontal) .ProductItem__Title'));
      titles.forEach(function (title) { title.style.minHeight = ''; });
      var titleHeight = Math.max(0, ...titles.map(function (title) { return Math.ceil(title.getBoundingClientRect().height); }));
      if (titleHeight) titles.forEach(function (title) { title.style.minHeight = titleHeight + 'px'; });
      var cards = Array.from(list.querySelectorAll('.ProductItem:not(.ProductItem--horizontal) .ProductItem__Info'));
      cards.forEach(function (card) { card.style.minHeight = ''; });
      var height = 0;
      cards.forEach(function (card) {
        if (!card.getBoundingClientRect().width) return;
        var naturalHeight = card.getBoundingClientRect().height;
        var expandedForm = card.querySelector('.lt-quick-shop[open] > .lt-quick-shop__form');
        if (expandedForm) naturalHeight -= expandedForm.getBoundingClientRect().height;
        height = Math.max(height, Math.ceil(naturalHeight));
      });
      if (height) cards.forEach(function (card) { card.style.minHeight = height + 'px'; });
    });
  }
  function scheduleAlignment() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(alignCarousels);
  }
  var resizeObserver = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var width = entry.contentRect.width;
      if (widths.get(entry.target) !== width) {
        widths.set(entry.target, width);
        scheduleAlignment();
      }
    });
  });
  function startAlignment() {
    scheduleAlignment();
    new MutationObserver(scheduleAlignment).observe(document.body, {childList:true, subtree:true});
    document.addEventListener('shopify:section:load', scheduleAlignment);
    window.addEventListener('resize', scheduleAlignment, {passive:true});
    if (document.fonts) document.fonts.ready.then(scheduleAlignment);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startAlignment);
  else startAlignment();
})();
  } catch(e) { console.error(e); }
})();

})();
